import React, { ReactElement } from 'react'
import styled from 'styled-components'
import { Alert, get } from '@ally/metronome-ui'

const StyledAlert = styled(Alert)`
  div {
    padding: 0;
    /* Remove display: block; when/if min-height: 306px (line 14) is removed */
    display: block;
    div {
      margin-left: ${get.space('xs')};
    }
  }
  min-height: 306px;
`
const WidgetError = ({ heading }: { heading?: string }): ReactElement => (
  <StyledAlert
    variant="error"
    disableContainer
    heading={
      heading ||
      "We're having trouble showing your information. We're working on a fix, so check back later."
    }
  />
)

export default WidgetError
